import React from 'react';

import NationalContacts from '../components/NationalContacts';

const NationalContactsPage = () => (
  <div style={{ minHeight: '600px' }}>
    <h2>
      National points of contact
    </h2>
    <p>
      National points of contact on the implementation of the
      Programme of Action and the International Tracing Instrument,
      communicated to UNODA by Member States{' '}.
      NPCs should be updated directly by Member States, whenever necessary, through updating and resubmitting their latest national reports.
    </p>

    <NationalContacts />
  </div>
);

export default NationalContactsPage



// WEBPACK FOOTER //
// ./src/pages/NationalContacts.js